/**
 * Config
 * ------
 * High level general purpose variables and settings
 */

// global elements
window.$b = $('body');
window.$w = $(window);

// app variables and functions
window.app = {
	breakpoints : {
	    xs: 0,
	    xsMax: 767,
	    md: 768,
	    mdMax: 1023,
	    lg: 1024,
	    lgMax: 1559,
	    xl: 1560
  },
  btnBorder: '<i class="tl"></i><i class="tr"></i><i class="br"></i><i class="bl"></i>'
};

/*
micro plugin to exclude child html when using .text()
https://stackoverflow.com/questions/11347779/jquery-exclude-children-from-text
*/
$.fn.ignore = function(sel){
  return this.clone().find(sel||">*").remove().end();
};